module.exports = __webpack_public_path__ + "img/banner-12.942fd530.jpg";